module.exports = __webpack_public_path__ + "img/closeGroup.f024b0e0.svg";